import React from 'react';

interface BonusData {
  casino: string;
  bonus: number;
  color: string;
}

interface BonusComparisonChartProps {
  data: BonusData[];
}

const BonusComparisonChart: React.FC<BonusComparisonChartProps> = ({ data }) => {
  const maxBonus = Math.max(...data.map((d) => d.bonus));

  return (
    <div className="space-y-4">
      {data.map((item, index) => (
        <div key={index}>
          <div className="flex justify-between mb-2">
            <span className="font-semibold">{item.casino}</span>
            <span className="text-accent-primary font-bold">£{item.bonus}</span>
          </div>
          <div className="w-full bg-dark-card rounded-full h-6 overflow-hidden">
            <div
              className={`h-full rounded-full transition-all duration-1000 flex items-center justify-end pr-2 ${item.color}`}
              style={{
                width: `${(item.bonus / maxBonus) * 100}%`,
              }}
            >
              <span className="text-xs font-semibold text-white">
                £{item.bonus}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BonusComparisonChart;

